"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _Discord = /*#__PURE__*/ _interop_require_default(require("./Discord"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let DiscordPlugin = class DiscordPlugin extends _ncplugin.XcWebhookNotificationPlugin {
    getAdapter() {
        return DiscordPlugin.notificationAdapter;
    }
    async init(_config) {
        DiscordPlugin.notificationAdapter = new _Discord.default();
        await DiscordPlugin.notificationAdapter.init();
    }
};
const _default = DiscordPlugin;
